import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import ContactPcsIcon from 'dibs-vg/dist/react/circle-contact-info';
import { PdpSharedBlurb } from './PdpSharedBlurb/PdpSharedBlurb';
import { pcsTitle, pcsText, messageCta } from '../messages/pdpBlurbMessages';

// styles
import styles from './PdpSharedBlurbs.scss';

// helpers
import get from 'lodash.get';

const WorkspaceContactVipRepModal = React.lazy(() =>
    import(
        /* webpackChunkName: "PdpContactVipRepModalChunk" */ 'dibs-workspace-intro-modal/exports/ContactVipRepModal'
    )
);

// todo ho: replace icon (see https://1stdibs.atlassian.net/browse/FINDING-11748)
export function PdpSharedBlurbPcsComponent({ user, item, vipUserRelationship, relay }) {
    const [isOpen, setIsOpen] = useState(false);
    const vipSalesRep = get(vipUserRelationship, 'userDataB[0]');
    const isVip = get(user, 'isVip');
    const userId = get(user, 'serviceId');

    if (!user || user.isVerifiedTrade || !isVip) {
        return null;
    }

    return (
        <PdpSharedBlurb IconComponent={ContactPcsIcon} dataTn="pdp-blurb-pcs">
            <div className={styles.vipPdpDiv}>
                <span className={styles.title}>{pcsTitle} </span>
                {pcsText(vipSalesRep.firstName)}
                <div className={styles.textDiv}>
                    {vipSalesRep.phoneNumber}
                    <div className={styles.pcsDivider} />
                    <div className={styles.messageCta} onClick={() => setIsOpen(true)}>
                        {messageCta(vipSalesRep.firstName)}
                    </div>
                </div>
                <React.Suspense fallback={null}>
                    <WorkspaceContactVipRepModal
                        isVip={isVip}
                        environment={get(relay, 'environment')}
                        isOpen={isOpen}
                        onClose={() => setIsOpen(false)}
                        itemId={get(item, 'serviceId')}
                        userId={userId}
                    />
                </React.Suspense>
            </div>
        </PdpSharedBlurb>
    );
}

PdpSharedBlurbPcsComponent.propTypes = {
    user: PropTypes.object,
    item: PropTypes.object,
    itemId: PropTypes.string,
    vipUserRelationship: PropTypes.object,
    relay: PropTypes.shape({
        environment: PropTypes.object,
    }),
};

export const PdpSharedBlurbPcs = createFragmentContainer(PdpSharedBlurbPcsComponent, {
    user: graphql`
        fragment PdpSharedBlurbPcs_user on User {
            serviceId
            isVerifiedTrade
            isVip
        }
    `,
    item: graphql`
        fragment PdpSharedBlurbPcs_item on Item {
            serviceId
        }
    `,
    vipUserRelationship: graphql`
        fragment PdpSharedBlurbPcs_vipUserRelationship on UserRelationship {
            userDataB {
                ... on VipRepData {
                    email
                    firstName
                    phoneNumber(formatType: INTERNATIONAL)
                }
            }
        }
    `,
});
